module.exports = __webpack_public_path__ + "img/behance.86752f1f.png";